export type El = JSX.Element | React.ComponentClass | string;
export interface Props {
  contentLabel?: string;
  el?: Element;
  footer?: El;
  header?: El;
  sidebar?: El;
  showModal: boolean;
  onClose?: () => void;
  onOpen?: () => void;
}
